export default __webpack_public_path__ + "static/media/imgDark5.9c12a615.png";